module.exports = __webpack_public_path__ + "assets/img/poster.e8e22b1a.jpg";